<template>
  <el-dropdown trigger="click" @visible-change="dropDownIcon" @command="handleCommand">
    <span class="el-dropdown-link" :class="{ bold: isBold }">
      <pp-icon type="ios-world-outline" size="20" class="mgr5" />
      {{ textFont[lang] || textFont.en }}
      <i :class="textIcon" />
    </span>
    <el-dropdown-menu slot="dropdown" class="lang-dropdown">
      <el-dropdown-item
        v-for="item in langOptions"
        :key="item"
        :command="item"
      >
        {{ textFont[item] }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
const normalizeLang = lang => {
  const value = (lang || '').toLowerCase()
  if (value.indexOf('zh') > -1) return 'zh'
  if (value.indexOf('ja') > -1) return 'ja'
  if (value.indexOf('en') > -1) return 'en'
  return ''
}

const timeZoneMap = {
  zh: 'UTC+8',
  ja: 'UTC+9',
  en: 'UTC+0'
}

export default {
  name: 'LangSwitch',
  props: {
    isBold: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lang: normalizeLang(localStorage.getItem('lang')) || normalizeLang(navigator.language) || 'en',
      textFont: {
        zh: '中文',
        en: 'EN',
        ja: '日本語'
      },
      textIcon: 'el-icon-arrow-down el-icon--right'
    }
  },
  computed: {
    langOptions() {
      return ['zh', 'en', 'ja'].filter(item => item !== this.lang)
    }
  },
  methods: {
    dropDownIcon(val) {
      if (val) this.textIcon = 'el-icon-arrow-up el-icon--right'
      else this.textIcon = 'el-icon-arrow-down el-icon--right'
    },
    handleCommand(val) {
      this.lang = val
      // reload page
      localStorage.setItem('lang', val)
      this.setTimeZone()
      setTimeout(() => {
        window.location.reload()
      }, 300)
    },
    setTimeZone() {
      // 设置时区 - 中文默认东八区，日语默认东九区，其他默认0时区
      localStorage.setItem('pp-timeZone', timeZoneMap[this.lang] || 'UTC+0')
    }
  }
}
</script>

<style lang="scss" scoped>
.el-popper {
    margin-top: 3px;
}
.el-dropdown-link {
	cursor: pointer;
  font-size: 16px;
  color: #666;
  &.bold {
    font-weight: 600;
  }
}
.mgr5 {
    margin-right: 3px;
}
.lang-dropdown {
    padding: 1px;
}
.pp-icon {
	-webkit-text-stroke-width: 0.2px;
  vertical-align: -2px;
}
</style>
